import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import HomeNavbarmenu from "../HomeFolder/HomeNavbarmenu";
import HomeSideNavbar from "../HomeFolder/HomeSideNavbar";
import AOS from "aos";
import "aos/dist/aos.css";
import "./LearningCalendarContent.css";
import LearningCalendarComponent from "./LearningCalendarComponent";
import Floaticons from "../../FunctionComponents/HomeFolder/Floaticons";
import HomeRightFloatIcons from "../../FunctionComponents/HomeFolder/HomeRightFloatIcons";

function LearningCalendarContent() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);
  const fiscalYear = `FY${
    new Date().getMonth() >= 8
      ? (new Date().getFullYear() + 1).toString().slice(-2)
      : new Date().getFullYear().toString().slice(-2)
  }`;
  return (
    <>
      <div className="navbar-holder">
        <HomeNavbarmenu />
      </div>
      <div className="home-sidenavbar-holder">
        <HomeSideNavbar />
      </div>
      <div className="video-container" id="main">
        <title>L-TT Learning Calendar</title>
        {/* <h1 class="sr-only" tabIndex={0}>
          Learning Calendar
        </h1> */}
        <img
          src={
            process.env.PUBLIC_URL +
            "/images/Banners/Learning-Calendar.png"
          }
          alt="lc-banner"
          className="banner-img"
        />
        <ul className="breadcrumbs">
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/Home"
            >
              L&TT Home
            </NavLink>
            <span>/</span>
          </li>
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/Learning-Calendar"
            >
              Learning Calendar
            </NavLink>
          </li>
        </ul>
        <div className="all-headings-text-box  learn-cal">
          <h1 tabIndex={0}>Learning Calendar</h1>
          <p>
            Explore L&TT's {fiscalYear} calendar - your guide to upcoming
            programs and offerings in technology, innovation, and delivery.
          </p>
        </div>
        {/* <p data-aos="fade-up">
          Lateral L&TT calendarized programs/ offerings on Technology,
          Innovation and Delivery learning for {fiscalYear}.
        </p> */}
        {/* <p data-aos="fade-up">
          Explore L&TT's {fiscalYear} calendar - your guide to upcoming programs
          and offerings in technology, innovation, and delivery.
        </p>
      </div> */}
      </div>
      <div className="learn-calen-container">
        <div className="learn-calen-wrap">
          <LearningCalendarComponent />
        </div>
      </div>
    </>
  );
}

export default LearningCalendarContent;
